module.exports = __webpack_public_path__ + "img/red-packet.de1575f1.png";